import axios from 'axios'
import * as Application from 'expo-application'
import { createContext, useContext, useEffect, useState } from 'react'
import { Platform } from 'react-native'
import Configuration from '../../../domain/services/ConfigurationService'
import useAuthentication from '../hooks/authentication/useAuthentication'
import LoadingScreen from '../screens/LoadingScreen'

enum FeatureStatus {
  NOT_LOADED,
  LOADING,
  SUCCESS,
}

const FeatureContext = createContext(null)
const { Provider } = FeatureContext

const FeatureProvider = ({ children }) => {
  const [status, setStatus] = useState<FeatureStatus>(FeatureStatus.NOT_LOADED)
  const { user, getAccessToken } = useAuthentication()
  const [features, setFeatures] = useState({})

  const CabanaApi = axios.create({
    baseURL: Configuration.CABANA_SERVICE_REST_URL,
  })
  CabanaApi.interceptors.request.use(async (config) => {
    config.headers.Authorization = await getAccessToken()
    config.headers['X-App-Version'] =
      Platform.OS === 'web'
        ? Configuration.WEB_VERSION
        : Application.nativeApplicationVersion
    config.headers['X-Platform'] = Platform.OS
    return config
  })

  const loadFeatures = () => {
    setStatus(FeatureStatus.LOADING)
    CabanaApi.get('/features')
      .then((response) => response.data)
      .then(setFeatures)
      .then(() => setStatus(FeatureStatus.SUCCESS))
      .catch(() => setStatus(FeatureStatus.NOT_LOADED))
  }

  useEffect(() => {
    if (user) loadFeatures()
  }, [user])

  return (
    <Provider value={{ features }}>
      {status === FeatureStatus.LOADING ? <LoadingScreen /> : children}
    </Provider>
  )
}

export { FeatureProvider }
export const useFeatures = () => useContext(FeatureContext)
